import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { useAuth, usePermissions } from '@luminovo/auth';
import { analytics } from '@luminovo/data-stack';
import { CenteredLayout, Link, LockFilledIcon, NonIdealState, Text } from '@luminovo/design-system';
import { Typography } from '@mui/material';
import { LogOutIcon } from 'lucide-react';

import { useTenantDetailsContext } from '../data/contexts/TenantDetailsContext';

export function NotAuthorizedPage() {
    const { permissions } = usePermissions();
    const { tenantDetails } = useTenantDetailsContext();
    const { logout } = useAuth({
        auth0OrgId: tenantDetails.external_auth_org_id ?? undefined,
    });

    const handleLogout = () => {
        analytics.track('logout');
        logout();
    };

    return (
        <CenteredLayout>
            <NonIdealState
                icon={<LockFilledIcon />}
                title={t`Not authorized`}
                description={
                    <Text style={{ marginTop: 16 }}>
                        <Trans>
                            It looks like you don't have access to this page. If you believe this is an error, please
                            contact us at{' '}
                            <Link href="mailto:support@luminovo.com" attention="low">
                                support@luminovo.com
                            </Link>{' '}
                            or send us a message over our chatbox.
                        </Trans>
                        <br />
                        {/* No navbar on a refused route; `/` sends each user type to its own landing page. */}
                        <Link to="/" attention="high">
                            <Trans>Go back to home</Trans>
                        </Link>
                    </Text>
                }
                action={{
                    onClick: handleLogout,
                    children: t`Log out`,
                    startIcon: <LogOutIcon />,
                }}
            />
            <details style={{ height: 40, minWidth: 320, textAlign: 'center', marginBlockStart: '-32px' }}>
                <summary>
                    <Typography
                        sx={{
                            display: 'inline',
                        }}
                    >
                        <Trans>View permissions</Trans>
                    </Typography>
                </summary>
                <pre style={{ marginTop: 8 }}>
                    {permissions.length === 0 ? <Trans>None</Trans> : permissions.join('\n')}
                </pre>
            </details>
        </CenteredLayout>
    );
}
